<template>
  <div :class="{ open: shouldShowOverlay }" class="video-overlay" @click.prevent="closeEmbedPage">
    <div class="video-modal">
      <div class="video-header">
        <div class="close-button" @click="closeEmbedPage">
          <inline-svg width="20" height="20" :src="require('../assets/images/close.svg')" />
        </div>
      </div>
      <div class="video-body" v-html="embedCode"></div>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';

export default {
  name: 'Home',
  data: function () {
    return {};
  },
  computed: {
    embedCode() {
      if (!this.embedPage.embedPageUrl) {
        return null;
      }

      return `<iframe src="${this.embedPage.embedPageUrl}" style="left:0;top:0;height:100%;width:100%;position:absolute;" frameborder="0" allow="autoplay; fullscreen" allowfullscreen></iframe>`;
    },
    shouldShowOverlay() {
      return !!this.embedPage.embedPageUrl && this.embedPage.isEmbedPageOpened;
    },
    ...mapState(['embedPage']),
  },
  methods: {
    ...mapActions({
      closeEmbedPage: 'closeEmbedPage',
    }),
  },
};
</script>
<style lang="scss" scoped>
.video-overlay {
  z-index: 999;
  position: fixed;
  display: flex;
  align-items: center;
  justify-content: center;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.4);
  opacity: 0;
  visibility: hidden;
  transition: visibility 0ms 200ms, opacity 200ms linear;

  &.open {
    opacity: 1;
    visibility: visible;
    transition: opacity 200ms linear;
  }

  .video-modal {
    width: 80%;
    display: flex;
    flex-direction: column;

    @media (max-width: 568px) {
      width: 100%;
    }

    .video-header {
      display: flex;
      flex-direction: row-reverse;

      .close-button {
        cursor: pointer;
        color: #637381;

        &:hover {
          color: white;
        }
      }
    }

    .video-body {
      background-color: black;
      line-height: 0;
      overflow: hidden;
      padding-bottom: 56.25%;
      position: relative;
      height: 0;
    }
  }
}
</style>
